// extracted by mini-css-extract-plugin
export default {"button":"e1noyh","link":"k4w7RI","mobileLink":"XlA8bk","root":"xAi6QB"};